import { Button } from "antd";
import { Can } from "@/shared/lib/casl";
import "@/entities/journal";
import "./section-second-actions.scss";

interface SectionSecondActionsProps {
  canSendToSign: boolean;
  canRejectSign: boolean;
  canReturn: boolean;
  canDelete: boolean;
  canVersions: boolean;
  canEdit: boolean;
  handleSendToSigning: () => void;
  setRejectOpen: (value: boolean) => void;
  handleReturnToWork: () => void;
  handleDelete: () => void;
  setHistoryOpen: (value: boolean) => void;
  handleEdit: () => void;
  handleClose: () => void;
}

export const SectionSecondActions = ({
  canSendToSign,
  canRejectSign,
  canReturn,
  canDelete,
  canVersions,
  canEdit,
  handleSendToSigning,
  setRejectOpen,
  handleReturnToWork,
  handleDelete,
  setHistoryOpen,
  handleEdit,
  handleClose,
}: SectionSecondActionsProps) => {
  return (
    <div className="journal-actions-bar">
      {canSendToSign && (
        <Can I="edit" a="section_2">
          <Button onClick={handleSendToSigning} style={{ height: 44 }}>
            Отправить на подписание
          </Button>
        </Can>
      )}
      {canRejectSign && (
        <Can I="edit" a="section_2">
          <Button style={{ height: 44 }} onClick={() => setRejectOpen(true)}>
            Отозвать с подписания
          </Button>
        </Can>
      )}
      {canReturn && (
        <Can I="edit" a="section_2">
          <Button onClick={handleReturnToWork} style={{ height: 44 }}>
            Вернуть в работу
          </Button>
        </Can>
      )}
      {canDelete && (
        <Can I="edit" a="section_2">
          <Button onClick={handleDelete} style={{ height: 44 }}>
            Удалить
          </Button>
        </Can>
      )}
      {canVersions && (
        <Button onClick={() => setHistoryOpen(true)} style={{ height: 44 }}>
          Версии
        </Button>
      )}
      {canEdit && (
        <Can I="edit" a="section_2">
          <Button onClick={handleEdit} style={{ height: 44 }}>
            Редактировать
          </Button>
        </Can>
      )}
      <Button onClick={handleClose} style={{ height: 44 }} type="primary">
        Закрыть
      </Button>
    </div>
  );
};

